const order = () => import('@/views/main/order/order.vue')
export default {
  path: '/main/order',
  name: 'order',
  component: order,
  children: []
}
